import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { dataMetaSelector } from "Bands/state";
import { dispatchGetEventAccommodationReservations } from "Bands/state/data/actions/eventBlocks/eventAccommodationReservation";
import { deleteAccommodationRoomType } from "Bands/state/data/actions/eventBlocks/eventAccommodationRoomType";
import { AccommodationRoomType, BAND_ACTIONS, IAccommodationRoomType } from "Bands/types";
import { useClearActionMetaOnUnMount } from "Bands/utils";
import { copy } from "shared/assets";
import { DeleteModal } from "shared/components";
import { addTemporaryToast } from "shared/components/Toast";
import { IAPIState, IStatus } from "shared/types";

const { accommodationBlock: blockCopy } = copy;

interface DeleteAccommodationRoomModalProps {
  accommodationRoom: IAccommodationRoomType;
  blockId: string;
  handleClose: () => void;
}

export const DeleteAccommodationRoomModal: React.FC<DeleteAccommodationRoomModalProps> = ({
  accommodationRoom: { id, name },
  blockId,
  handleClose,
}) => {
  const dispatch = useDispatch();

  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.deleteAccommodationRoomType));

  useClearActionMetaOnUnMount(BAND_ACTIONS.deleteAccommodationRoomType);

  useEffect(() => {
    if (apiMeta?.status === IAPIState.succeeded) {
      dispatchGetEventAccommodationReservations({
        dispatch,
        blockId,
        page: 1,
      });

      handleClose();

      dispatch(
        addTemporaryToast({
          status: IStatus.success,
          message: blockCopy.create.roomsBlock.messages.delete,
        })
      );
    }
  }, [apiMeta?.status, blockId, dispatch, handleClose]);

  const handleDelete = () => {
    dispatch(deleteAccommodationRoomType({ id, blockId }));
  };

  const error = useMemo(() => !!apiMeta?.error, [apiMeta?.error]);

  return (
    <DeleteModal
      name={
        AccommodationRoomType[name as keyof typeof AccommodationRoomType] ||
        name ||
        "type_placeholder"
      }
      type="room type"
      dataTestId="accommodation_room_delete_modal"
      apiMeta={apiMeta}
      handleClose={handleClose}
      handleDelete={handleDelete}
      error={error}
    />
  );
};
